import { render, staticRenderFns } from "./view_goods.vue?vue&type=template&id=51a145f4&scoped=true"
import script from "./view_goods.vue?vue&type=script&lang=js"
export * from "./view_goods.vue?vue&type=script&lang=js"
import style0 from "./view_goods.vue?vue&type=style&index=0&id=51a145f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a145f4",
  null
  
)

export default component.exports